<template>
    <div v-if="!!market.name" id="stena-footer" :class="[footerTheme]">
        <div class="content">
            <ul v-for="(row, index) in information" class="content-list" :key="index">
                <li v-for="(item, itemIndex) in row" :key="itemIndex">
                    <a v-if="item.href" :href="getLinkUrl(item.href)">
                        {{ item.text }}
                    </a>
                    <span v-else>
                        {{ item.text }}
                    </span>
                </li>
            </ul>
        </div>
        <div class="osano-content" v-if="showCookieConsent">
            <ButtonText iconPosition="left" icon="Cookie" :onClick="showOsanoDrawer">
                {{ t({ key: 'shared.cookie_settings' }) }}
            </ButtonText>
        </div>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, PropType } from 'vue';
    import { Market } from '@shared/config/market/market.models';
    import { FooterTheme, LogoTheme } from '../../Layout.interfaces';
    import { t } from '@shared/helpers/translation';
    import ButtonText from '@ui/components/Button/ButtonText.vue';

    export default defineComponent({
        name: 'StenaFooter',
        components: { ButtonText },
        methods: {
            t,
            showOsanoDrawer(): void {
                if (window.Osano) {
                    window.Osano.cm.showDrawer();
                }
            },
        },
        props: {
            market: {
                type: Object as PropType<Market>,
                required: true,
            },
            logoTheme: {
                type: String as PropType<LogoTheme>,
                required: true,
                default: 'inverted',
            },
            footerTheme: {
                type: String as PropType<FooterTheme>,
                required: true,
                default: 'primary',
            },
        },
        setup(props) {
            const information = computed(() => props.market.footerInfo);

            const showCookieConsent = computed(() => window.Osano);

            function getLinkUrl(url: string) {
                if (url.startsWith('/')) {
                    return props.market.homePage + url;
                }
                return url;
            }

            return {
                information,
                showCookieConsent,
                getLinkUrl,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @use '@/styles/import.scss' as *;

    #stena-footer {
        padding: 33px 0;

        &.primary {
            background-color: #fff !important;
        }

        &.transparent {
            background-color: transparent;
        }

        & > .content {
            display: -ms-flexbox;
            display: flex;
            margin-right: auto;
            margin-left: auto;
            margin-bottom: var(--spacing-40);
            -ms-flex-pack: center;
            justify-content: center;
            max-width: 1120px;
            -ms-flex-direction: column;
            flex-direction: column;

            & > .content-list {
                margin-top: 0;
                padding: 0;
                list-style: none;
                display: -ms-flexbox;
                display: flex;
                -ms-flex-pack: center;
                justify-content: center;

                & > li {
                    margin-left: var(--spacing-32);
                    text-align: center;

                    &:first-child {
                        margin-left: 0;
                    }
                }
            }
        }

        a {
            color: #2864cb !important;
            text-decoration: underline;
        }
        .osano-content {
            @include flex(row, center, center);
            button,
            button:deep(svg) {
                color: #2864cb !important;
            }
        }
    }

    @media (max-width: 767px) {
        #stena-footer {
            padding: 20px 0;
        }
    }
</style>
